class InfoTooltip extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-content]");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      this.details.open ? this.close() : this.open();
    });

    this.summary.addEventListener("mouseover", () => {
      this.open();
    });

    this.summary.addEventListener("mouseleave", () => {
      this.close();
    });

    this.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;

      this.close();
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}

  open() {
    if (this.details.open) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.details.open = true;
    this.details.classList.add("open");
  }

  close() {
    if (!this.details.open) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.details.classList.remove("open");
    } else {
      this.details.open = false;
    }
  }
}

if (!customElements.get("info-tooltip")) {
  customElements.define("info-tooltip", InfoTooltip);
}
